// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"2f265575","134":"7f93338d","145":"4bafe047","251":"824f12fe","437":"8ff28f7e","512":"bc926132","916":"8ff28f7e","954":"b644b40c"}[chunkId] + ".chunk.css";
};